<template>
  <b-modal
    id="tilesetModal"
    title="Загрузка тайлсета"
    ref="tilesetModal"
    header-bg-variant="primary"
    header-text-variant="light"
    ok-title="Сохранить"
    cancel-title="Отмена"
    ok-variant="primary"
    cancel-variant="outline-primary"
    @ok="onSave"
    @shown="onShown"
    :ok-disabled="okDisabled"
    size="lg"
  >
    <b-button @click="onTextureUpload" variant="outline-primary">
      Загрузить текстуру
    </b-button>
    <b-button @click="onJsonUpload" variant="outline-primary" class="ml-2">
      Загрузить JSON
    </b-button>
    <b-row class="mt-3">
      <b-col sm="6">
        <strong>Текстура</strong><br>
        <img
          v-if="textureFile"
          :src="'/api/files/' + textureFile.physicalName"
          class="img-fluid"
        />
        <em v-else class="text-center"> Текстура не выбрана </em>
      </b-col>
      <b-col sm="6">
        <strong>JSON-файл</strong><br>
        <div v-if="formattedJson" class="overflow-auto" style="max-height: 350px">
          <pre v-html="formattedJson" />
        </div>
        <em v-else class="text-center">JSON-файл не выбран</em>
      </b-col>
    </b-row>
    <v-modal-files-upload
      modalId="tileset-texture-upload-modal"
      wrkspcType="img"
      :fileHandler="onTextureUploaded"
    />
    <UploadCodeModal @fileUploaded="onJsonUploaded" accept="application/json" />
  </b-modal>
</template>

<script>
import UploadCodeModal from '@/components/content/education/training/modals/UploadCodeModal.vue'
import VModalFilesUpload from '@/components/content/edit/modals/ModalFilesUpload.vue'

export default {
  name: 'TilesetModal',
  components: {
    UploadCodeModal,
    VModalFilesUpload
  },
  data() {
    return {
      textureFile: null,
      tilesetJson: null,
      formattedJson: null
    }
  },

  computed: {
    okDisabled() {
      return !this.textureFile || !this.tilesetJson
    }
  },
  methods: {
    onSave() {
      this.$emit('fileReady', {
        file: this.textureFile,
        json: this.tilesetJson
      })
    },
    onShown() {
      this.textureFile = null
      this.tilesetJson = null
      this.formattedJson = null
    },
    onTextureUpload() {
      this.$bvModal.show('tileset-texture-upload-modal')
    },
    onTextureUploaded(files) {
      [this.textureFile] = files
      this.$bvModal.hide('tileset-texture-upload-modal')
    },
    onJsonUpload() {
      this.$bvModal.show('importModal')
    },
    onJsonUploaded(json) {
      this.tilesetJson = json
      this.formattedJson = JSON.stringify(JSON.parse(json), null, 4)
    }
  }
}
</script>

<style scoped>
</style>
